import { jsxs as p, jsx as i } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import f from "@mui/material/Button";
import a from "styled-components";
import { getSize as l, getFontSize as h, getColor as x, getBackground as C, getBorderColor as B, getColorHover as y, getBackgroundHover as v, getBorderColorHover as w, hexToRgba as k, getColorPress as R, getBackgroundPress as P, getBorderColorPress as S, getColorDisabled as I, getBackgroundDisabled as z, sizes as s } from "../../theme/utils/styleUtils.js";
import D from "../CircularProgress/CircularProgress.js";
const F = {
  root: "buttonRoot",
  label: "buttonLabel",
  focusVisible: "buttonFocusVisible",
  disabled: "buttonDisabled",
  startIcon: "buttonStartIcon",
  endIcon: "buttonEndIcon"
}, E = (o) => {
  let t = "8px 16px";
  return o === s.small && (t = "4px 16px"), o === s.extraSmall && (t = "2px 16px"), t;
}, H = a(f).withConfig({
  displayName: "StyledButton"
})([
  "&&.buttonRoot{min-height:",
  ";height:",
  ";font-size:",
  ";line-height:1.2em;text-transform:none;font-weight:",
  ";padding:",
  ";color:",
  ";background-color:",
  ";border:solid 1px ",
  ";box-shadow:none;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;display:inline-block;}&&.buttonRoot:hover{color:",
  ";background-color:",
  ";border:solid 1px ",
  ";}&&.buttonRoot.buttonFocusVisible{box-shadow:0px 0px 4px 0px ",
  ";}&&.buttonRoot:active{color:",
  ";background-color:",
  ";border:solid 1px ",
  ";}&&.buttonDisabled{color:",
  ";background-color:",
  ";border:solid 1px transparent;}&&.buttonRoot .buttonStartIcon,&&.buttonRoot .buttonEndIcon{display:inline;vertical-align:middle;line-height:0;}"
], ({ $size: o }) => l(o), ({ $size: o }) => l(o), ({ $size: o }) => h(o), ({ theme: o }) => o.typography.fontWeightMedium, ({ $size: o }) => E(o), ({ $flavor: o, theme: t, variant: e }) => x(t, e, o), ({ $flavor: o, theme: t, variant: e }) => C(t, e, o), ({ $flavor: o, theme: t, variant: e }) => B(t, e, o), ({ $flavor: o, theme: t, variant: e }) => y(t, e, o), ({ $flavor: o, theme: t, variant: e }) => v(t, e, o), ({ $flavor: o, theme: t, variant: e }) => w(t, e, o), ({ theme: o }) => k(o.primaryFocus, o.isLightTheme ? 0.5 : 1), ({ $flavor: o, theme: t, variant: e }) => R(t, e, o), ({ $flavor: o, theme: t, variant: e }) => P(t, e, o), ({ $flavor: o, theme: t, variant: e }) => S(t, e, o), ({ theme: o, variant: t }) => I(o, t), ({ theme: o, variant: t }) => z(o, t)), N = a.div.withConfig({
  displayName: "ProgressContainer"
})([
  "position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);line-height:0;"
]), V = /* @__PURE__ */ m(({ children: o, classes: t, disabled: e = !1, flavor: d = "normal", loading: r = !1, loadingSize: u = 24, variant: n = "contained", size: b = "medium", ...c }, g) => /* @__PURE__ */ p(H, {
  ref: g,
  ...c,
  variant: n,
  classes: {
    ...F,
    ...t
  },
  $size: b,
  $flavor: d,
  disableElevation: !0,
  disabled: e || r,
  children: [
    o,
    r && n !== "text" && /* @__PURE__ */ i(N, {
      children: /* @__PURE__ */ i(D, {
        size: u
      })
    })
  ]
}));
V.displayName = "Button";
export {
  V as default
};
